import Component from 'Component';
import GroupSwitch from "./price-manager/GroupSwitch";
import TableSwitch from "./price-manager/TableSwitch";
import PriceTable from "./price-manager/PriceTable";

export default class PriceManager extends Component {

  _namespace = this.constructor.name;

  _components = [
    new TableSwitch(this.App, this._namespace),
    new GroupSwitch(this.App, this._namespace),
    new PriceTable(this.App, this._namespace),
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}